// extracted by mini-css-extract-plugin
export default {"site":"day_site__DFWDY","homeLink":"day_homeLink__CR2iB","text":"day_text__Eohb0","clock":"day_clock__ALQnt","color":"day_color__rkqbl","effect":"day_effect__a4gsg"};